import axios from 'axios'
import config from '@/config'
const candidateService = {
  getCandidateInfo(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/profile/candidate/candidateinfo',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          console.error(e)
          reject(e.response)
        })
    })
  },
  fetchCandidateDetails(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/profile/candidate/candidatedetails',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  fetchCandidateProfileById(context, data) {
    // This is a recruiter only api.
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/findbyid?candidate_id=${data.candidateId}&bookingid=${data.bookingId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  fetchCandidateDetailsById(context, data) {
    console.log('data: ', data)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/findbyid?candidate_id=${data.id}${
            data.pf ? '&progressFlow=true' : ''
          }`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  fetchCandidateDetailsByIdPrivate(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/profile/candidate/private/findbyid?candidate_id=${data.id}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createProfile(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/create',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateProfileByRecruiter(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/update/byrecruiter',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateProfile(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/update',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  addExperience(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/insert/experience',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateExperience(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/update/experience',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteExperience(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/delete/experience',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  addEducation(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/insert/education',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateEducation(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/update/education',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteEducation(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/delete/education',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  addLanguage(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/insert/language',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateLanguage(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/update/language',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteLanguage(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/delete/language',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  addSkill(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/insert/skill',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteSkill(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/profile/candidate/delete/skill',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteProfilePic(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/deleteprofilepic',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteProfileVid(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/deleteprofilevideo',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getCandidateInterviewVideo(videoId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/jobcode/webex/interview?videoid=${videoId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createDoc(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/create/doc',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateDoc(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/update/doc',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteDoc(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/profile/candidate/delete/doc',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
}
export default candidateService
